export const setTopNavbar = (obj) => ({
    type: 'SET_TOP_NAVBAR_OBJECT',
    payload: {
        ...obj,
        title: obj.title || "HYK",
        showBackArrow: obj.showBackArrow !== undefined ? obj.showBackArrow : true,
    }
})

export const clearTopNavbar = () => ({
    type: 'SET_TOP_NAVBAR_OBJECT',
    payload: {
        title: "HYK",
        showBackArrow: true,
    }
})